import { createSlice } from '@reduxjs/toolkit'

const getInitialToken = () => {
  const activeRole = localStorage.getItem('activeRole')
  if (activeRole === 'owner') return localStorage.getItem('ownerToken')
  if (activeRole === 'staff') return localStorage.getItem('staffToken')
  return localStorage.getItem('token')
}

const initialState = {
  token: getInitialToken() || null,
  user: null,
  isAuthenticated: !!getInitialToken(),
  role: localStorage.getItem('activeRole') || null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user, role } = action.payload
      state.token = token
      state.user = user
      state.isAuthenticated = true
      state.role = role

      localStorage.setItem('activeRole', role)

      if (role === 'owner') {
        localStorage.setItem('ownerToken', token)
        // Clear staff tokens from previous session
        localStorage.removeItem('staffToken')
        localStorage.removeItem('token')
      } else {
        localStorage.setItem('staffToken', token)
        localStorage.setItem('token', token)
        // Clear owner token from previous session
        localStorage.removeItem('ownerToken')
      }

      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      }
    },
    logout: (state) => {
      state.token = null
      state.user = null
      state.isAuthenticated = false
      state.role = null
      localStorage.removeItem('token')
      localStorage.removeItem('ownerToken')
      localStorage.removeItem('staffToken')
      localStorage.removeItem('activeRole')
      localStorage.removeItem('user')
      localStorage.removeItem('loginConfirmationPending')
    },
    updateUser: (state, action) => {
      state.user = action.payload
      localStorage.setItem('user', JSON.stringify(action.payload))
    },
  },
})

export const { setCredentials, logout, updateUser } = authSlice.actions
export default authSlice.reducer

